import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import _, { add } from "lodash";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import * as loaderAction from "../../redux/loader/action";
import * as paramsAction from "../../redux/gameParams/actions";
import Play from "../../assets/images/verboden/play.png";
import avatar from "../../assets/images/OCH/avatar.png";
import addBot from "../../assets/images/OCH/addBot.png";
import XIcon from "../../assets/images/OCH/X.png";
import { removeUser } from "../shared/utils";
import Alert from "../shared/common/alert";
import Socket from "../../socket/socket";

const OCHPlayers = (props) => {
  let roomData = props.gameReducer.roomObj;
  let playersData = props.gameReducer.roomObj.users;
  let gameObj = props?.paramsReducer?.gameObj?.screens?.lobby;
  let currentroomObj = props.gameReducer.roomObj;
  const gameName = props.gameReducer.gameName;
  const status = _.get(roomData, "game_state.status");
  const [round, setRound] = useState(
    gameName && gameName !== "" && gameName === "OCH" ? 4 : 10
  );
  const [allUsers, setAllUsers] = useState([]);

  const available_user_id = () => {
    let taken_user_id = [];
    playersData.forEach((user) => {
      taken_user_id.push(user?.player_id);
    });
    let all_user_id = [1, 2, 3, 4];
    let arr = all_user_id.filter((item) => !taken_user_id.includes(item));
    return arr[0];
  };

  let bot_userid = "bot-" + available_user_id();
  useEffect(() => {
    props.setIsLoading(false);
  }, []);

  useEffect(() => {
    let realUser = [];
    let botUser = [];
    playersData &&
      playersData.length > 0 &&
      playersData.forEach((item) => {
        if (item.user_id.includes("bot")) {
          botUser.push(item);
        } else {
          realUser.push(item);
        }
      });
    if (realUser.length === 0) {
      botUser &&
        botUser.length > 0 &&
        botUser.map((bot) => {
          const roomObj = props.gameReducer.roomObj;
          removeUser(roomObj, bot);
        });
    }
  }, [JSON.stringify(playersData)]);

  useEffect(() => {
    return Socket.addListener("update-status", async (res) => {
      props.history.push("/ochos-locos");
    });
  }, []);
  useEffect(() => {
    return Socket.addListener("join-room", async (res) => {
      props.setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.history.push("/ochos-locos");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };

  const add_Bot = () => {
    props.setIsLoading(true);
    let data = {
      action: "join-room",
      joinCode: currentroomObj.join_code,
      userId: bot_userid,
      name: bot_userid,
      profileImage: "profileImage"
    };
    Socket.sendMessage(data);
  };

  const imgError = (e) => {
    e.target.src = avatar;
  };
  const onStartGame = () => {
    if (playersData && playersData.length < 2) {
      Alert(400, "Need at least 2 players to start the game");
      return;
    } else {
      let data = {
        action: "update-status",
        roomId: roomData.id,
        maxRounds: parseInt(round),
        // scoreToWin: parseInt(round),
        tableTopName: "OCHOS LOCOS"
      };
      Socket.sendMessage(data);
    }
  };

  const comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };

  useEffect(() => {
    let { gameReducer } = props;
    let roomObj = _.get(gameReducer, "roomObj");
    if (Object.keys(roomObj).length > 0 && roomObj.users.length > 0) {
      if (roomObj.users.length > allUsers.length) {
        let result = roomObj.users.filter(comparer(allUsers));
        playAudio(
          // result && result[0].audio_effect ? result[0].audio_effect : ""
          result && result[0].audio_effect ? result[0].audio_effect : ""
        );
        setAllUsers(roomObj.users);
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length < allUsers.length
    ) {
      setAllUsers(roomObj.users);
    }
  }, [props.gameReducer.roomObj]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  return (
    <div className="och-players-wrapper">
      <h2>{gameObj ? gameObj.lobby_label : "Players Joined"}</h2>
      <div className="players-wrapper">
        {playersData &&
          playersData.length > 0 &&
          playersData.map((item, index) => {
            return (
              // <Player key={index} {...data} />
              <div className="och-players-box">
                <div className="och-player-image">
                  <img
                    // src={item.profile_image !== '' ? item.profile_image : avatar}
                    src={
                      item.profile_image
                        .toString()
                        .includes("default-profile-icon")
                        ? avatar
                        : item.profile_image.toString().includes("profileImage")
                        ? avatar
                        : item.profile_image
                    }
                    className=""
                    onError={(e) => imgError(e)}
                    alt=""
                  />
                </div>
                <h3 className="och-player-name">{item.display_name}</h3>
                <Button
                  color="ochTheme"
                  className="cross-btn"
                  onClick={() => delPlayer(item)}
                >
                  <img src={XIcon} alt="cross" />
                </Button>
              </div>
            );
          })}
        {playersData.length > 0 && playersData.length < 4 && (
          <div className="och-players-box">
            <div className="addBotImg">
              <img src={addBot} onClick={() => add_Bot()} alt="" />
            </div>
          </div>
        )}
      </div>
      <div className="start-btn">
        <Button color="ochThemeGreen" onClick={onStartGame}>
          <img src={Play} className="mr-2" alt="" />
          {gameObj ? gameObj.button_text : "Start"}
        </Button>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});
const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(OCHPlayers);
